<!-- Historical Summary Section -->
<ng-container
  *ngIf="loaded() && insight.identifier === 'JBTStandardObservationId'">

    <div class="compact-row">
      <div *ngIf="insight.display.title?.display" class="compact-title"
          [style.textAlign]="insight.display.title?.alignment || 'left'"
          [style.fontSize]="insight.display.title?.size || '14px'">
          {{ insight.display.title?.textOverride || 'Historical Insight' }}
      </div>
    </div>

  

    <ng-container>
      <div style="padding: 10px;">
        <lib-chunkprogressbar-insight
          [chunkProgressTotal]="20"
          [min]="0"
          [max]="100"
          [value]="value"
          [progressCssStyle]="{ 'background':'#007bff' }">
        </lib-chunkprogressbar-insight>
      </div>
      <div>
        <ion-card-subtitle style="text-align: right">{{ insight.statisticalConfig?.operation || insight.statisticalConfig?.comparisonType }}</ion-card-subtitle>
      </div>
    </ng-container>


<!-- 
  <div>
    <ion-row class="threshold-results">
      <ion-col size="12" class="ion-text-center">
        <ion-label>
          @if(insight.statisticalConfig?.comparisonType == 'percentage') {
            <h3>{{ value | percent }}</h3>
          }
          @else {
            <h3>{{ value | number:'1.1-1' }}</h3>
          }

          <p>{{ insight.statisticalConfig?.operation || insight.statisticalConfig?.comparisonType }}</p>
        </ion-label>
      </ion-col>
    </ion-row>
  </div> -->
</ng-container>



<!-- No Data -->
<!-- <ion-item *ngIf="records.length === 0 && loaded()">
  <ion-label class="ion-text-wrap">
    <ion-card-title>{{ insight.display.title?.textOverride || 'Historical Tag Insight' }}</ion-card-title>
    <p>No historical data available for the selected time range.</p>
  </ion-label>
</ion-item> -->

<!-- Skeleton Loader -->
<ion-list *ngIf="loading()">
  <ion-list-header>
    <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
  </ion-list-header>
  <ion-item *ngFor="let i of [1, 2, 3]">
    <ion-thumbnail slot="start">
      <ion-skeleton-text [animated]="true"></ion-skeleton-text>
    </ion-thumbnail>
    <ion-label>
      <h3><ion-skeleton-text [animated]="true" style="width: 80%;"></ion-skeleton-text></h3>
      <p><ion-skeleton-text [animated]="true" style="width: 60%;"></ion-skeleton-text></p>
      <p><ion-skeleton-text [animated]="true" style="width: 30%;"></ion-skeleton-text></p>
    </ion-label>
  </ion-item>
</ion-list>
